import { SET_IS_DARK_MODE, SET_LANGUAGE, SET_LICENSE_SETTINGS, SET_TEXT_SIZE } from './chunk-WXPNHPDE.mjs';
import { __export } from './chunk-T36PI2YV.mjs';

// src/state/settings/licenseSettings/actions.ts
var actions_exports = {};
__export(actions_exports, {
  setIsDarkMode: () => setIsDarkMode,
  setLanguage: () => setLanguage,
  setLicenseSettings: () => setLicenseSettings,
  setTextSize: () => setTextSize
});
var setIsDarkMode = (payload) => ({
  type: SET_IS_DARK_MODE,
  payload
});
var setLanguage = (payload) => ({
  type: SET_LANGUAGE,
  payload
});
var setLicenseSettings = (payload) => ({
  type: SET_LICENSE_SETTINGS,
  payload
});
var setTextSize = (payload) => ({
  type: SET_TEXT_SIZE,
  payload
});

export { actions_exports, setIsDarkMode, setLanguage, setLicenseSettings, setTextSize };
